module.exports = __webpack_public_path__ + "img/steve.287b9bec.jpg";